import { useEffect } from "react";

export const useOnClickOutside = (
    ref,
    handler,
    mouseEvent = 'mousedown',
) => {
    useEffect(() => {
        const listener = event => {
            if (!ref.current || ref.current.contains(event.target)) return

            handler(event)
        }

        document.addEventListener(mouseEvent, listener)

        return () => {
            document.removeEventListener(mouseEvent, listener)
        }
    }, []);
}
